const patternAnime = document.querySelectorAll('.pattern-animation');

patternAnime.forEach((pattern) => {
  if (pattern.closest('.swiper-slide')) return;
  playPatternAnimation(pattern, true);
});
